import { awaitPendingRegistrationStart, hasPendingRegistrationStart } from '../utils/emailStepRegistration';

/**
 * POST /registration/complete com fallback de versão.
 *
 * Se o hosting estiver à frente do apiV2 (incidente Raiane 28/08/2026),
 * a primeira tentativa com a versão do bundle leva 400. A segunda omite
 * o campo e o backend grava a versão que ele conhece — o funil não trava.
 */
export async function postRegistrationComplete({
  apiBaseUrl,
  patientId,
  termsOfUseVersion,
  timeoutMs = 15000,
}) {
  const url = String(apiBaseUrl || '').replace(/\/+$/, '');
  // Sem timeout, uma conexão pendurada deixava o botão "Aceitar Termos" em
  // estado de envio indefinidamente, sem mensagem nem como tentar de novo.
  // Abortar propaga o erro, e o caller mostra a falha e reabilita o botão —
  // mesmo padrão de `Persistence.recoverOrCreatePatientId`.
  const post = async (body) => {
    const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), timeoutMs) : null;
    try {
      const res = await fetch(`${url}/registration/complete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: ctrl ? ctrl.signal : undefined,
      });
      const data = await res.json().catch(() => null);
      return { res, data };
    } finally {
      if (timer) clearTimeout(timer);
    }
  };

  if (hasPendingRegistrationStart()) await awaitPendingRegistrationStart();
  let { res, data } = await post({ patientId, termsOfUseVersion });
  const mismatch =
    data &&
    data.success !== true &&
    data.loadingTrap !== true &&
    data.blocked !== true &&
    data.tacRequired !== true &&
    (data.code === 'TERMS_VERSION_MISMATCH' || /desatualizada/i.test(String(data.error || '')));
  if (mismatch) {
    ({ res, data } = await post({ patientId }));
  }
  return { res, data };
}

/**
 * O limiter de `/registration` responde `{ error: "too_many_requests" }`.
 * Esse código não pode ir para a tela: o paciente vê a string crua e acha
 * que o aceite travou. Frase em português; outros códigos de máquina
 * (snake_case) caem na mensagem genérica. Texto já em português passa.
 */
export function patientFacingTermsAcceptError(data, fallback) {
  const fb =
    fallback ||
    'Não foi possível registrar o aceite. Toque de novo em alguns segundos.';
  const raw = data && data.error != null ? String(data.error).trim() : '';
  if (!raw) return fb;
  if (raw === 'too_many_requests' || raw === 'rate_limit_unavailable') {
    return 'Não foi possível registrar o aceite agora. Toque em Aceitar Termos de novo.';
  }
  if (/^[a-z0-9_]+$/.test(raw)) return fb;
  return raw;
}
